import { uniqBy } from 'lodash';

const flattenArray = (deepArray) => [...new Set(deepArray.flat().filter((item) => !!item))];

export const getRolesForOrgFunction = (orgFunc = {}) => {
  const { grades, childFunctions } = orgFunc;
  let roles = [];
  if (Array.isArray(grades)) {
    const rolesForOrgFunc = [];
    grades.forEach((grade) => {
      const { roles } = grade;
      roles.forEach((role) => {
        rolesForOrgFunc.push(role.role);
      });
    });
    const uniqueRolesForGrade = uniqBy(rolesForOrgFunc, 'uuid');
    roles = [...roles, ...uniqueRolesForGrade];
  }

  if (Array.isArray(childFunctions)) {
    let childFunctionRoles = childFunctions.map((orgFunc) => getRolesForOrgFunction(orgFunc));
    childFunctionRoles = flattenArray(childFunctionRoles);
    childFunctionRoles = uniqBy(childFunctionRoles, 'uuid');
    roles = [...roles, ...childFunctionRoles];
  }

  return roles;
};

const rolesOfFunctionAndChildFunctions = (childFunctions) => {
  let orgFunctionsAndRoles = [];
  if (Array.isArray(childFunctions)) {
    orgFunctionsAndRoles = childFunctions.map((orgFunc) => {
      const roles = getRolesForOrgFunction(orgFunc);
      return {
        function: orgFunc.function,
        roles,
        childFunctions: rolesOfFunctionAndChildFunctions(orgFunc.childFunctions),
      };
    });
  }
  return orgFunctionsAndRoles;
};

export default class OrganizationFunctionsAndRoles {
  constructor(orgFunctionsAndRoles) {
    this.orgFunctionsAndRoles = orgFunctionsAndRoles;
  }

  toFuncAndRoles(childFunctions) {
    const orgFunctionsAndRoles = rolesOfFunctionAndChildFunctions(childFunctions);
    return new OrganizationFunctionsAndRoles(orgFunctionsAndRoles);
  }
}
